import React, { Component, PropTypes } from 'react';
import Button from 'muicss/lib/react/button';

class GbpVerificationSubmission extends Component {
    static propTypes = {
        setVerificationCode: PropTypes.func,
        messageText: PropTypes.string,
        resendVerificationCode: PropTypes.func,
        isCodeSent: PropTypes.bool,
        timer: PropTypes.number,
        countDown: PropTypes.func,
        setVerificationCodeStatus: PropTypes.func,
        setTimerValue: PropTypes.func
    };
    constructor() {
        super();
    }

    componentDidMount() {
        this.initiateCountDown();
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    initiateCountDown = () => {
        const { countDown, setVerificationCodeStatus } = this.props;
        this.intervalId = setInterval(() => {
            if (this.props.timer > 0) {
                countDown();
            } else {
                clearInterval(this.intervalId);
                setVerificationCodeStatus(false);
            }
        }, 1000);
    }

    handleResendButtonClick = () => {
        const { resendVerificationCode, setTimerValue } = this.props;
        
        setTimerValue(60);
        this.initiateCountDown();

        resendVerificationCode();
    }

    render() {
        const { setVerificationCode, messageText, isCodeSent, timer } = this.props;
        const isResendDisabled = isCodeSent || timer > 0;
        return (
            <div>
                <p>
                    {messageText}
                </p>
                <div className={1 == 2 ? 'common-custom-input input-with-error' : 'common-custom-input'}>
                    <label className={'common-custom-label'}>Code</label>
                    <input
                        id='code'
                        name='code'
                        className={'classic rounded max-w-300 min-w-300 mb-12 mr-20 google-code'}
                        type='text'
                        placeholder='6-digit code'
                        onChange={(event) => setVerificationCode(event.target.value)}
                    />
                    <div className={'mui-divider mt-10'}></div>
                    <p className={'mt-10 text-italic'}> Resend verification code in {timer} seconds </p>
                    <div>
                        <Button className='mui-btn--secondary content-width mt-10'
                            type='button'
                            disabled={isResendDisabled}
                            size={'small'}
                            onClick={this.handleResendButtonClick}
                        >
                            Resend verification code
                        </Button>
                    </div>

                </div>
            </div>
        );
    }
}

export default GbpVerificationSubmission;
